// This file was auto-generated by Fern from our API Definition.
/** Controls the verbosity of usage examples in README generation */
const ExampleStyleValues = {
    Minimal: "minimal",
    Comprehensive: "comprehensive",
};
export const ExampleStyle = Object.assign(Object.assign({}, ExampleStyleValues), { _visit: (value, visitor) => {
        switch (value) {
            case ExampleStyle.Minimal:
                return visitor.minimal();
            case ExampleStyle.Comprehensive:
                return visitor.comprehensive();
            default:
                return visitor._other();
        }
    } });
